import React, { Component } from "react";
import DataTable from "react-data-table-component";
const paginationOptions = {
  rangeSeparatorText: "de",
  noRowsPerPage: true
};
export default class TarjetaCreditoAdicionalPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disponibles: props.disponibles,
      valor: props.prueba
    };
  }
  componentDidMount() { }
  getColumn() {
    return [
      {
        cell: (row) => (
          <button className="btn btn-cu-primary btn-block btn-sm" style={{ margin: "0 auto" }} onClick={(e) => { this.handleSelect(row) }}>
            Seleccionar
          </button>
        ),
        width: "130px",
      },
      {
        cell: (row) => (
          <img src={row.tarjetaURL} style={{ width: "70px", height: "60px", margin: "0 auto", padding: "10px 0" }} alt="Imágen de la Tarjeta de Crédito"></img>
        ),
        // width: "150px",
      },
      {
        name: "Tipo",
        selector: "tipo",
        width: "220px"
      },
      {
        name: "Línea",
        selector: "linea",
        width: "200px"
      },
    ];
  }
  handleSelect = (tarjetaSeleccionada) => {
    this.props.selectorValuePopUp(tarjetaSeleccionada);
  };
  render(props) {
    var tarjetaAdicionalList = this.props.tarjetaAdicionalList;
    var tarjetaTitular = this.props.tarjetaTitular;
    return (
      <div className="modal fade" id={this.props.idModal} data-backdrop="static">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="row" style={{ display: "contents" }}>
                <div className="col-md-12" style={{ fontSize: 25, color: "#4a4a4a" }}>
                  Tarjetas Activas
                </div>
              </div>
            </div>
            <div className="modal-body" style={{ minHeight: 50 }}>
              <div className="row">
                <div className="col-md-12">
                  <label className="input-label-bold">
                    Tarjeta Titular
                  </label>
                </div>
              </div>
              <div className="row">
                <DataTable
                  noHeader={true}
                  pagination={false}
                  columns={this.getColumn()}
                  data={tarjetaTitular}
                  dense={true}
                  noDataComponent="No hay registros para mostrar"
                  responsive={true}
                  striped={true}
                />
              </div>
              <div className="row" style={{ marginTop: 20 }}>
                <div className="col-md-12">
                  <label className="input-label-bold">
                    Tarjetas Adicionales
                  </label>
                </div>
              </div>
              <div className="row">
                <DataTable
                  noHeader={true}
                  pagination={true}
                  columns={this.getColumn()}
                  data={tarjetaAdicionalList}
                  dense={true}
                  paginationComponentOptions={paginationOptions}
                  noDataComponent="No hay registros para mostrar"
                  responsive={true}
                  striped={true}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-cu-primary" data-dismiss="modal">
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}